var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// src/utils/body-lock.js
var BodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
  }
};
var body_lock_default = new BodyLock();

// src/utils/debounce.js
var debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// src/utils/modal.js
var _hideOnClickOutside, hideOnClickOutside_fn, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn;
var Modal = class {
  constructor(modalHandlerElement, options) {
    __privateAdd(this, _hideOnClickOutside);
    __privateAdd(this, _getCorrectModalByAriaControls);
    __publicField(this, "sendUpdateModalState", (state, ariaControls, modalHandlerElement) => {
      const event = new CustomEvent("modal:state", {
        detail: {
          state,
          ariaControls: `${ariaControls}`,
          element: modalHandlerElement ? modalHandlerElement : null
        }
      });
      document.dispatchEvent(event);
    });
    this.ariaControls = modalHandlerElement.getAttribute("aria-controls");
    this.options = options;
    this.initModalHandler(modalHandlerElement, options);
    document.addEventListener("modal:open", (event) => {
      const ariaControls = event.detail.ariaControls;
      const modalHandlerElement2 = event.detail.modalHandlerElement;
      this.openModal(modalHandlerElement2, ariaControls);
    }, true, { passive: false });
    document.addEventListener("modal:close", (event) => {
      const ariaControls = event.detail.ariaControls;
      const modalHandlerElement2 = event.detail.modalHandlerElement;
      this.closeModal(modalHandlerElement2, ariaControls);
    }, true, { passive: false });
  }
  getCurrentState(ariaControls) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    if ((modal == null ? void 0 : modal.status) === false)
      return;
    const ariaHidden = modal == null ? void 0 : modal.getAttribute("aria-hidden");
    if (ariaHidden === "true") {
      return {
        state: "closed",
        isModalOpen: false
      };
    } else {
      return {
        state: "open",
        isModalOpen: true
      };
    }
  }
  openModal(modalHandlerElement, ariaControls) {
    var _a;
    if (!ariaControls) {
      ariaControls = modalHandlerElement.getAttribute("aria-controls");
    }
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const parentElement = modal.parentElement;
    const closeAllActiveModals = modalHandlerElement.getAttribute("data-close-all-active-modals-on-open") || "false";
    const disableBodyLock = modalHandlerElement.getAttribute("data-disable-bodylock") || "false";
    this.sendUpdateModalState("open", ariaControls, modalHandlerElement);
    modal.setAttribute("aria-hidden", "false");
    modalHandlerElement.setAttribute("aria-expanded", "true");
    modalHandlerElement.setAttribute("aria-pressed", "true");
    if (disableBodyLock !== "true") {
      body_lock_default.lock();
    }
    if (((_a = this.options) == null ? void 0 : _a.parentIsOverlay) === true) {
      parentElement == null ? void 0 : parentElement.setAttribute("aria-hidden", "false");
    }
    if (closeAllActiveModals === "true") {
      const allActiveModals = document.querySelectorAll('modal-handler[aria-pressed="true"]');
      allActiveModals.forEach((activeModalHandler) => {
        if (activeModalHandler === modalHandlerElement)
          return;
        this.closeModal(activeModalHandler, activeModalHandler.getAttribute("aria-controls"));
      });
    }
    __privateMethod(this, _hideOnClickOutside, hideOnClickOutside_fn).call(this, modal, ariaControls, modalHandlerElement);
  }
  closeAllActiveModals() {
    const allActiveModals = document.querySelectorAll('modal-handler[aria-pressed="true"]');
    allActiveModals.forEach((activeModalHandler) => {
      this.closeModal(activeModalHandler, activeModalHandler.getAttribute("aria-controls"));
    });
  }
  closeModal(modalHandlerElement, ariaControls) {
    var _a;
    if (!ariaControls) {
      ariaControls = modalHandlerElement.getAttribute("aria-controls");
    }
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const parentElement = modal.parentElement;
    const removeBodyLock = modalHandlerElement.getAttribute("data-remove-bodylock") || "true";
    const closeAllActiveModals = modalHandlerElement.getAttribute("data-close-all-active-modals") || "false";
    this.sendUpdateModalState("close", ariaControls, modalHandlerElement);
    modal.setAttribute("aria-hidden", "true");
    modalHandlerElement.setAttribute("aria-expanded", "false");
    modalHandlerElement.setAttribute("aria-pressed", "false");
    if (((_a = this.options) == null ? void 0 : _a.parentIsOverlay) === true) {
      parentElement == null ? void 0 : parentElement.setAttribute("aria-hidden", "true");
    }
    if (closeAllActiveModals === "true") {
      this.closeAllActiveModals();
    }
    if (removeBodyLock === "true") {
      body_lock_default.unlock();
    }
  }
  handleModal(modalHandlerElement) {
    const ariaControls = modalHandlerElement.getAttribute("aria-controls");
    const currentState = this.getCurrentState(ariaControls);
    if (!currentState)
      return;
    if (currentState.isModalOpen == true) {
      this.closeModal(modalHandlerElement, ariaControls);
    } else {
      this.openModal(modalHandlerElement, ariaControls);
    }
  }
  initModalHandler(modalHandlerElement, options) {
    if ((options == null ? void 0 : options.disableDefaultClick) === true) {
    } else {
      modalHandlerElement.addEventListener("click", (event) => {
        const ariaControls = modalHandlerElement.getAttribute("aria-controls");
        const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
        if ((modal == null ? void 0 : modal.status) == false) {
        } else {
          event.preventDefault();
          this.handleModal(modalHandlerElement);
        }
      }, true, { passive: true });
    }
    if ((options == null ? void 0 : options.toggleOnHover) === true) {
      modalHandlerElement.addEventListener("mouseenter", debounce(() => {
        const ariaControls = modalHandlerElement.getAttribute("aria-controls");
        const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
        if ((modal == null ? void 0 : modal.status) == false) {
          this.closeAllActiveModals();
        } else {
          this.openModal(modalHandlerElement, ariaControls);
          modal.addEventListener("mouseout", debounce((event) => {
            const targetElement = event.relatedTarget;
            if ((targetElement == null ? void 0 : targetElement.closest('[aria-modal="true"]')) || (targetElement == null ? void 0 : targetElement.closest("header"))) {
            } else {
              this.closeModal(modalHandlerElement, ariaControls);
            }
          }, true, { passive: true }), 100);
        }
      }, true, { passive: true }), 100);
    }
    if ((options == null ? void 0 : options.parentIsOverlay) === true) {
      const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, this.ariaControls);
      if (!modal.status)
        return;
      const parentElement = modal.parentElement;
      const currentState = this.getCurrentState(this.ariaControls);
      if (!currentState)
        return;
      parentElement.setAttribute("aria-hidden", !currentState.isModalOpen);
    }
  }
};
_hideOnClickOutside = new WeakSet();
hideOnClickOutside_fn = function(modal, ariaControls, modalHandlerElement) {
  const outsideClickListener = (event) => {
    var _a;
    const target = event.target;
    const predictiveSearchElement = document.querySelector("predictive-search");
    if (target === modal && (target == null ? void 0 : target.classList.contains("modal-overlay"))) {
      this.closeModal(modalHandlerElement, ariaControls);
      removeClickListener();
    } else if (target === modalHandlerElement || (target == null ? void 0 : target.parentElement) === modalHandlerElement || (target == null ? void 0 : target.getAttribute("aria-controls")) || ((_a = target == null ? void 0 : target.parentElement) == null ? void 0 : _a.getAttribute("aria-controls")) || (target == null ? void 0 : target.closest('[aria-modal="true"]'))) {
    } else {
      this.closeModal(modalHandlerElement, ariaControls);
      removeClickListener();
    }
  };
  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };
  document.addEventListener("mousedown", outsideClickListener);
};
_getCorrectModalByAriaControls = new WeakSet();
getCorrectModalByAriaControls_fn = function(ariaControls) {
  const modalElement = document.querySelector(`[aria-modal="true"][aria-labelledby="${ariaControls}"]`);
  if (modalElement) {
    return modalElement;
  } else {
    console.warn(`No modal was found for ${ariaControls}`);
    return {
      error: `No modal was found for ${ariaControls}`,
      status: false
    };
  }
};
var modal_default = Modal;

// src/extenders/modal-handler.js
var ModalHandlerElement = class extends HTMLElement {
  constructor() {
    super();
    const modalHandlerElement = this;
    const modalHandlerElementParentOverlay = modalHandlerElement.getAttribute("data-parent-is-overlay");
    const modalHandlerElementTOggleOnHover = modalHandlerElement.getAttribute("data-toggle-on-hover");
    const modalHandlerElementDisableClick = modalHandlerElement.getAttribute("data-disable-click");
    const options = {};
    if (modalHandlerElementParentOverlay && modalHandlerElementParentOverlay === "true") {
      Object.assign(options, { parentIsOverlay: true });
    }
    if (modalHandlerElementTOggleOnHover && modalHandlerElementTOggleOnHover === "true") {
      Object.assign(options, { toggleOnHover: true });
    }
    if (modalHandlerElementDisableClick && modalHandlerElementDisableClick === "true") {
      Object.assign(options, { disableDefaultClick: true });
    }
    new modal_default(modalHandlerElement, options);
  }
};
if (customElements.get("modal-handler") === void 0) {
  customElements.define("modal-handler", ModalHandlerElement);
}
